import type { QuoteRecord, Ticket } from '../types';

const QUOTE_ID_RE = /Auto-created from quote (q_[a-z0-9_]+)/i;
const BOOKING_LINK_QUOTE_RE = /[?&]q=(q_[a-z0-9_]+)/i;

export function parseQuoteIdFromTicket(ticket: Ticket): string | null {
  const fromHeader = QUOTE_ID_RE.exec(ticket.description);
  if (fromHeader?.[1]) return fromHeader[1];
  const fromLink = BOOKING_LINK_QUOTE_RE.exec(ticket.description);
  return fromLink?.[1] ?? null;
}

export function isQuoteFollowUpTicket(ticket: Ticket): boolean {
  return ticket.tags.includes('quote') || parseQuoteIdFromTicket(ticket) != null;
}

export function quoteEmailWasSent(quote: QuoteRecord): boolean {
  return Boolean(quote.emailsSent?.quote);
}

export function ticketReceiptEmailWasSent(quote: QuoteRecord): boolean {
  return Boolean(quote.emailsSent?.ticket);
}
